<template>
  <div class="app-container questionnaire-list">
    <div class="questionnaire-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="questionnaire-list-filter-value" v-model.trim="listQuery.name" @keyup.enter.native="searchChange" clearable size="small" placeholder="名称" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="questionnaire-list-filter-value" v-model="listQuery.isPublish" clearable size="small" placeholder="状态">
              <el-option
                v-for="item in publishOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-date-picker
              class="questionnaire-list-filter-date"
              v-model="time"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              size="small"
              @change="queryTimeChange"
              placeholder="创建时间">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-button class="questionnaire-list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
            <el-button class="questionnaire-list-filter-search" size="small" @click="searchChange">立即筛选</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <avue-crud ref="crud"
                 :page.sync="page"
                 :data="tableData"
                 :table-loading="tableLoading"
                 :option="tableOption"
                 @current-change="currentChange"
                 @size-change="sizeChange">

        <template slot="name" slot-scope="scope">
           <div class="name">
             <div class="cover-image" v-if="scope.row.coverUrl" v-viewer>
              <img :src="scope.row.coverUrl | ossImageProcess">
            </div>
            <a href="javascript:void(0);" @click="handleView(scope.row,scope.index)"
                class="questionnaire-list-container-button">
                {{scope.row.name}}
            </a>
           </div>
        </template>

        <template slot="miniProgramCodeUrl" slot-scope="scope">
          <el-button type="text" @click="previewMiniProgramQrcode(scope.row.id)">
            点击查看
          </el-button>
        </template>

        <template slot="menuLeft">
          <el-button type="primary"
            @click="handleAdd"
            icon="el-icon-plus"
            v-if="permissions.questionnaire_create"
            size="small">新增</el-button>
          <br /><br />
        </template>

        <template slot="qrUrl" slot-scope="scope">
          <el-button type="text" @click="previewImg(scope.row.qrUrl)">
            <div>modules/questionnaire/detail/{{ scope.row.id }}</div>
          </el-button>
        </template>

        <template slot-scope="scope"
          slot="menu">
          <el-button type="text"
            icon="el-icon-view"
            size="mini"
            v-if="permissions.questionnaire_view"
            @click="handleView(scope.row,scope.index)">查看</el-button>
          <el-button size="mini"
            type="text"
            icon="el-icon-mobile-phone"
            @click="openQuestionnaireQrCodeDialog(scope.row.id)">预览</el-button>
          <el-button type="text"
            icon="el-icon-edit"
            size="mini"
            v-if="permissions.questionnaire_edit"
            @click="handleEdit(scope.row,scope.index)">编辑</el-button>
          <el-button type="text"
            icon="el-icon-tickets"
            size="mini"
            v-if="permissions.questionnaire_create"
            @click="handleCopy(scope.row,scope.index)">复制</el-button>
          <el-button type="text"
            icon="el-icon-upload2"
            size="mini"
            v-if="permissions.questionnaire_status_update && !scope.row.isPublish"
            @click="handleStatusUpdate(scope.row,scope.index, 1)">上架</el-button>
          <el-button type="text"
            icon="el-icon-download"
            size="mini"
            v-if="permissions.questionnaire_status_update && !!scope.row.isPublish"
            @click="handleStatusUpdate(scope.row,scope.index, 2)">下架</el-button>
          <el-button type="text"
            icon="el-icon-delete"
            size="mini"
            v-if="permissions.questionnaire_del"
            @click="handleDelete(scope.row,scope.index)">删除</el-button>
          <!-- <el-button type="text"
            icon="el-icon-view"
            size="mini"
            v-if="permissions.questionnaire_view"
            @click="handlePreview(scope.row,scope.index)">预览</el-button>
          <el-button
            title="复制链接"
            size="mini"
            type="text"
            icon="el-icon-share"
            @click="copyLink(scope.row)">复制链接</el-button> -->
        </template>
      </avue-crud>
    </basic-container>
    <el-dialog
      title="请使用微信扫描预览二维码"
      :visible.sync="questionnaireQrCodeDialogVisible"
      width="40%"
      center>
      <span slot="footer" class="dialog-footer">
       <el-row>
        <div class="qr-code">
        <div class="qr-code-content">
          <div class="qr-code-img">
            <vue-qr :text="questionnaireZhQrCodeValue" size="150"></vue-qr>
          </div>
          <p class="qr-code-url">中文预览</p>
        </div>
        <div class="qr-code-content">
          <div class="qr-code-img">
            <vue-qr :text="questionnaireEnQrCodeValue" size="150"></vue-qr>
          </div>
          <p class="qr-code-url">英文预览</p>
        </div>
        </div>
        <p class="qr-code-url">链接地址</p>
        <p class="qr-code-url">中文：{{questionnaireZhQrCodeValue}}</p>
        <p class="qr-code-url">英文：{{questionnaireEnQrCodeValue}}</p>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="imgDialogVisible"
      fullscreen
      custom-class="preview-img-dialog">
      <div @click="imgDialogVisible = false">
        <vue-qr :text="previewImgUrl" :size="qrCodeSize"></vue-qr>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="userPreviewQrcodeDialogVisible"
      fullscreen
      custom-class="preview-img-dialog">
      <div @click="userPreviewQrcodeDialogVisible = false">
        <vue-qr :text="userPreviewQrcodeUrl" :size="qrCodeSize"></vue-qr>
      </div>
    </el-dialog>
        <el-dialog
      :title="(isPublish ? '上架' : '下架') + '问卷'"
      :visible.sync="updateStatusConfimrDialogVisible"
      width="35%"
      @close="handleUpdateStatusDialogClose">
      <template>
         <el-row class="dialog-body-row">您确定要{{(isPublish ? '上架' : '下架')}}该问卷吗？</el-row>
       </template>
       <!-- <template>
        <el-row class="dialog-body-row">
          <el-input type="textarea" :rows="3" v-if="isNeedSendMessageToScopeMembers" v-model="messageToScopeMembers" :maxlength="500"></el-input>
        </el-row>
        <el-row class="dialog-body-row">
          <el-checkbox label="发短信给该问卷范围的所有用户" v-model="isNeedSendMessageToScopeMembers"></el-checkbox>  
        </el-row>
       </template> -->
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="updateStatusConfimrDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleConfirmUpdateStatus">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="miniprogramQrcodeDialogVisible"
      fullscreen
      custom-class="preview-img-dialog"
      @closed="previewMiniProgramQrcodeUrl=''">
      <div @click="miniprogramQrcodeDialogVisible = false">
        <img :src="previewMiniProgramQrcodeUrl"/>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import vueQr from 'vue-qr';
import { mapGetters } from "vuex";
import { getQuestionnaireList, delQuestionnaire, updateQuestionnaireStatus, copyQuestionnaire, getQuestionnaireMiniProgramCode } from '@/api/app/questionnaire'
import { tableOption, publishOptions, viewAnswerResultTypeOptions, paperModeOptions, anonymousOptions, publicOptions } from '@/const/crud/app/questionnaire'
import { formatDate } from '@/util/date';
import  API from '@/api/app/activity'

export default {
  name: 'questionnaire',
  data() {
    return {
      tableOption,
      publishOptions,
      viewAnswerResultTypeOptions,
      paperModeOptions,
      anonymousOptions,
      publicOptions,
      imgDialogVisible: false,
      previewImgUrl: '',
      userPreviewQrcodeDialogVisible: false,
      userPreviewQrcodeUrl: '',
      qrCodeSize: 300,
      tableLoading: false,
      tableData: [],
      time: [],
      listQuery: {
        current: 1,
        size: 10,
        type: '',
        startTime: '',
        endTime: '',
        name: '',
        isAnonymous: '',
        isPublic: '',
        paperMode: '',
        isPublish: undefined,
      },
      page: {
        total: 0, // 总记录数
        currentPage: 1, // 当前页数
        pageSize: 10 // 每页显示多少条
      },
      updateStatusConfimrDialogVisible: false,
      isNeedSendMessageToScopeMembers: false,
      messageToScopeMembers: '',
      updateStatus: undefined,
      updateStatusQuestionnaireId: undefined,
      isPublish: true,
      previewMiniProgramQrcodeUrl: '',
      miniprogramQrcodeDialogVisible: false,
      questionnaireQrCodeDialogVisible: false,
      questionnaireZhQrCodeValue: '',
      questionnaireEnQrCodeValue: '',
    }
  },
  created() {
    this.getList();
  },
  activated() {
    this.getList();
  },
  computed: {
  ...mapGetters(['permissions']),
  },
  methods: {
    openQuestionnaireQrCodeDialog(id) {
      this.questionnaireQrCodeDialogVisible = true;
      this.questionnaireZhQrCodeValue = process.env.VUE_APP_BASIC_PAGE_PATH + `/questionnaire-preview/${id}?lang=zh`;
      this.questionnaireEnQrCodeValue = process.env.VUE_APP_BASIC_PAGE_PATH + `/questionnaire-preview/${id}?lang=en`;
    },
    queryTimeChange(value) {
      this.listQuery.startTime = value[0];
      this.listQuery.endTime = value[1];
    },
    formatData(records) {
      if (Array.isArray(records)) {
        records.forEach(record => {
          record.viewAnswerResultType = viewAnswerResultTypeOptions.find((v) => (v.value == record.viewAnswerResultType)).label;
          record.paperMode = paperModeOptions.find((v) => (v.value == record.paperMode)).label;
          record.status = record.isPublish ? '已上架' : '已下架';
          record.isPublish = record.isPublish;
          record.activityName = record.activityName ? record.activityName : '--';
          record.projectLecturer = record.projectLecturer ? record.projectLecturer : '--';
          record.totalScore = record.totalScore !== undefined ? record.totalScore : '--';
          record.averageScore = record.averageScore !== undefined ? record.averageScore : '--';
          record.projectName = record.projectName ? record.projectName : '--';

          record.qrUrl = !record.qrUrl ? '--' : record.qrUrl;
          if (!record.creatorName) {
            record.creatorName = '--';
          } else {
            // 获取到的createName固定格式为admin:xxx, 需要去掉admin:
            const matchResult = record.creatorName.match(/(?<=admin:)([\s\S]*)/g);
            record.creatorName = !matchResult ? '--': matchResult[0];
          }

          record.isAnonymous = record.isAnonymous ? '是' : '否';
          record.isPublic = record.isPublic ? '是' : '否';
        })
      }
      return records
    },
    searchReset() {
      this.time = []
      this.listQuery = {}
      this.searchChange()
    },
    searchChange() {
      this.page.currentPage = 1
      this.listQuery.current = 1
      this.getList()
    },
    currentChange(val) {
      this.page.currentPage = val
      this.listQuery.current = val
      this.getList()
    },
    sizeChange(val) {
      this.page.currentPage = 1
      this.listQuery.current = 1
      this.page.pageSize = val
      this.listQuery.size = val
      this.getList()
    },
    handleAdd: function() {
      this.$router.push({
        path: '/app/questionnaire/add'
      })
    },
    handleEdit(row, index) {
      this.$router.push({
        path: `/app/questionnaire/edit/${row.id}`
      });
    },
    handleCopy(row, index) {
      this.$confirm(`是否确定复制问卷'${row.name}'?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$message({
            type: 'warning',
            message: '复制问卷中...',
            duration: 0,
          });
          copyQuestionnaire(row.id).then(response => {
            loading.close();
            this.$message({
              type: 'success',
              message: '问卷复制成功',
            });
            this.getList();
          });
        });
    },
    handleView(row, index) {
       this.$router.push({
        path: `/app/questionnaire/detail/${row.id}`,
      })
    },
    handlePreview(row, index) {
      this.userPreviewQrcodeUrl = `${row.qrUrl}?isPreview=true`;
      this.userPreviewQrcodeDialogVisible = true;
    },
    copyLink(row) {
      const url = process.env.VUE_APP_BASIC_PAGE_PATH + `/modules/questionnaire/detail/${row.id}`
      this.$copyText(url).then(
        res => {
          this.$message({
            showClose: true,
            type: 'success',
            message: '已成功复制'
          })
        },
        err => {
          this.$message({
            showClose: true,
            type: 'error',
            message: '失败'
          })
        }
		  )
    },
    handleDelete(row, index) {
      const params = {
        questionnaireId: row.id,
        projectId: row.projectId
      }
      if (row.projectId) {
        API.checkIsRelateProject(params).then(response => {
          if (response.data.data) {
            this.$message({
              showClose: true,
              message: '此问卷已关联培训项目，暂不能删除',
              type: 'error'
            });
          } else {
            this.deleteQuestionnaire(row);
          }
        });
      } else {
        this.deleteQuestionnaire(row);
      }
    },
    deleteQuestionnaire(row) {
      this.$confirm('是否确认删除：' + row.name + ' ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delQuestionnaire(row.id).then(response => {
          if (response.data.data) {
            let totalPage = Math.ceil((this.page.total - 1) / this.page.pageSize)
            let currentPage =this.page.currentPage > totalPage ? totalPage : this.page.currentPage
            this.listQuery.current = currentPage < 1 ? 1 : currentPage
            this.getList();
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success'
            });
          }
        })
      }).catch(()=>{});
    },
    handleStatusUpdate(row, index, updateStatus) {
      this.updateStatus = updateStatus;
      this.updateStatusConfimrDialogVisible = true;
      this.updateStatusQuestionnaireId = row.id;
      this.isPublish = (updateStatus === 1);
    },
    getList() {
      this.tableLoading = true
      getQuestionnaireList(this.listQuery).then(response => {
        this.tableData = this.formatData(response.data.data.records);
        this.page.total = response.data.data.total;
        this.tableLoading = false;
      }).catch(error => {
        console.error(error)
        this.$message({
          message: '获取问卷列表失败',
          type: 'error'
        })
        this.tableLoading = false;
      })
    },
    previewImg(url) {
      this.previewImgUrl = url;
      this.imgDialogVisible = true;
    },
    handleConfirmUpdateStatus() {
      // if (this.isNeedSendMessageToScopeMembers && (this.messageToScopeMembers === '' ||this.messageToScopeMembers.trim() === '')) {
      //   this.$message.error('短信内容不能为空');
      // }

      updateQuestionnaireStatus(this.updateStatusQuestionnaireId, this.updateStatus, this.isNeedSendMessageToScopeMembers, this.messageToScopeMembers).then(response => {
        this.getList();
        this.updateStatusConfimrDialogVisible = false;
        this.$message.success(this.updateStatus === 1 ? '已上架' : '已下架');
      });
    },
    handleUpdateStatusDialogClose() {
      this.updateStatus = undefined;
      this.updateStatusQuestionnaireId = undefined;
      this.isNeedSendMessageToScopeMembers = false;
      this.messageToScopeMembers = '';
    },
    previewMiniProgramQrcode(questionnaireId) {
      const messageRef = this.$message({
        message: "获取小程序二维码中...",
        type: "warning",
        duration: 0,
      });
      setTimeout(() => {
        getQuestionnaireMiniProgramCode(questionnaireId).then((response) =>{
          messageRef.close();
          this.previewMiniProgramQrcodeUrl = response.data.data;
          this.miniprogramQrcodeDialogVisible = true;
        });
      }, 1000);
    }
  }
}
</script>

<style lang="scss" scoped>
.questionnaire-list {
  .questionnaire-cover-image {
    display: inline-block;
    width: fit-content;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-reset {
      margin-left: 10px;
    }
    &-search {
      margin-left: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: left;
      font-weight: 500;
      width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .clamp-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .dialog-body-row {
    margin-top: 8px;
  }
}
.name {
  display: flex;
  align-items: center;
  .cover-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}
/deep/ .el-dialog.preview-img-dialog{
  background: rgba(0, 0, 0, 0.5);
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 40px;
      right: 40px;
      .el-dialog__close {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        border: 2px solid #fff;
        border-radius: 50%;
        padding: 5px;
      }
    }
  }
  .el-dialog__body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0;
    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}

/deep/ .el-dialog.preview-img-dialog{
  background: rgba(0, 0, 0, 0.5);
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 40px;
      right: 40px;
      .el-dialog__close {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        border: 2px solid #fff;
        border-radius: 50%;
        padding: 5px;
      }
    }
  }
  .el-dialog__body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0;
    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}
.qr-code {
  display: flex;
  .qr-code-content {
    flex: 1;
    .qr-code-img {
      width: 150px;
      height: 150px;
      margin: 0 auto;
      margin-top: -40px;
      padding: 12px;
      border: 1px solid rgb(230, 230, 230);
      border-radius: 8px;
      background-color: rgb(245, 245, 245);
    }
  }
}
.qr-code-url {
  color: #606266;
}
</style>

